<template>
  <a-card class="relative">
    <a-button class="back" @click="backHandle">返回</a-button>
    <Globalnfo :info="detail.info"></Globalnfo>
    <a-tabs
      v-model:activeKey="detail.activeKey"
      @change="taskChange"
      v-if="detail.from != 'main'"
    >
      <a-tab-pane
        :key="item.id"
        :tab="item.number"
        v-for="item in detail.subTask"
      >
        <a-card class="mt20" title="基本信息" v-if="detail.from != 'main'">
          <div class="wrap">
            <div class="con">
              <dl>
                <dt>状态：</dt>
                <dd v-if="detail.info.type == 'tag'">
                  <span v-if="detail.subInfo.state == 'to_be_labeled'"
                    >待筛选</span
                  >
                  <span v-else-if="detail.subInfo.state == 'in_labeling'"
                    >筛选中</span
                  >
                  <span v-else="detail.subInfo.state == 'to_be_labeled'">{{
                    stateCn(detail.subInfo.state)
                  }}</span>
                </dd>
                <dd v-else>{{ stateCn(detail.subInfo.state) }}</dd>
              </dl>
              <dl class="ml20">
                <dt v-if="detail.info.type == 'tag'">筛选说明：</dt>
                <dt v-else>标注说明：</dt>
                <dd>
                  <a
                    :href="detail.info.descriptionLink"
                    target="_blank"
                    download
                    >下载</a
                  >
                </dd>
              </dl>
              <dl class="ml20" v-if="detail.info.type == 'tag'">
                <dt>标签：</dt>
                <dd>{{ detail.info.tags.join(",") }}</dd>
              </dl>
            </div>

            <div class="con">
              <dl>
                <dt>数量：</dt>
                <dd>{{ detail.subInfo.detailTotal }}</dd>
              </dl>
              <dl class="ml20">
                <dt>标注员：</dt>
                <dd v-if="detail.subInfo.labelerName == '待指派'">
                  ({{ detail.subInfo.labelerName }})
                </dd>
                <dd v-else>{{ detail.subInfo.labelerName }}</dd>
              </dl>
              <dl class="ml20">
                <dt>质检员：</dt>
                <dd v-if="detail.subInfo.labelerName == '待指派'">
                  ({{ detail.subInfo.inspectorName }})
                </dd>
                <dd v-else>{{ detail.subInfo.inspectorName }}</dd>
              </dl>
              <dl class="ml20">
                <dt>标注框数量：</dt>

                <dd>{{ detail.subInfo.labelCount }}</dd>
              </dl>
            </div>
          </div>
        </a-card>

        <!-- <div v-if="labelData.list[0] ">
          {{ labelData.list[0] }}
        </div> -->

        <div v-if="detail.type === 'view'">
          <a-card class="label-wrap mt20" title="标注数据">
            <!--  start ---->
            <!-- 质检  -->

            <div class="clearfix">
              <a-form
                class="mb20 fr"
                v-if="true"
                layout="inline"
                :model="searchForm"
              >
                <a-form-item>
                  <a-input
                    v-model:value="searchForm.keyword"
                    placeholder="请输入文件名查询"
                  >
                  </a-input>
                </a-form-item>

                <a-form-item>
                  <a-button @click="search" type="primary" html-type="submit">
                    查询
                  </a-button>
                </a-form-item>
              </a-form>
            </div>

            <ul
              class="label-list"
              v-if="
                detail.subInfo.state == 'to_be_inspected' ||
                detail.subInfo.state == 'in_inspecting' ||
                detail.subInfo.state == 'inspection_failed'
              "
            >
              <li
                :class="{ choose: item.isChoose }"
                v-for="(item, index) in labelData.list"
                :key="item.id"
                @click="viewResult(item, index, 'img' + index)"
                :ref="'img' + index"
              >
                <figure>
                  <!-- appConfig.baseImgUrl + item.item.accessSrc  -->
                  <!--   @click=""   previewImg(index) -->
                  <a-image
                    style="width: auto; max-height: 157px"
                    :preview="false"
                    :src="appConfig.baseImgUrl + item.item.accessSrc"
                    fallback="data:image/png;base64,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"
                  >
                  </a-image>
                  <figcaption
                    class="fig"
                    :class="{
                      error: item.qualityState == 'failure',
                      sucess: item.qualityState == 'success',
                    }"
                  >
                    <p class="name">{{ item.item.id }}</p>
                  </figcaption>
                </figure>
                <a-tag
                  v-if="item?.tags?.length"
                  color="#2db7f5"
                  style="
                    position: absolute;
                    right: -10px;
                    top: -10px;
                    border-radius: 5px;
                  "
                  >{{ item.tags[0] }}</a-tag
                >
              </li>
            </ul>
            <!-- 初验  -->
            <ul
              class="label-list"
              v-else-if="
                detail.subInfo.state == 'to_be_accepted' ||
                detail.subInfo.state == 'in_accepting' ||
                detail.subInfo.state == 'acceptance_completed'
              "
            >
              <li
                :class="{ choose: item.isChoose }"
                v-for="(item, index) in labelData.list"
                :key="item.id"
                @click="viewResult(item, index, 'img' + index)"
                :ref="'img' + index"
              >
                <figure>
                  <!-- appConfig.baseImgUrl + item.item.accessSrc  -->
                  <!--   @click=""   previewImg(index) -->
                  <a-image
                    style="width: auto; max-height: 157px"
                    :preview="false"
                    :src="appConfig.baseImgUrl + item.item.accessSrc"
                    fallback="data:image/png;base64,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"
                  >
                  </a-image>
                  <figcaption
                    class="fig"
                    :class="{
                      error: item.acceptanceState == 'failure',
                      sucess: item.acceptanceState == 'success',
                    }"
                  >
                    <p class="name">{{ item.item.id }}</p>
                  </figcaption>
                </figure>
                <a-tag
                  v-if="item?.tags?.length > 0"
                  color="#2db7f5"
                  style="
                    position: absolute;
                    right: -10px;
                    top: -10px;
                    border-radius: 5px;
                  "
                  >{{ item.tags[0] }}</a-tag
                >
              </li>
            </ul>

            <!-- 待提交  -->
            <ul
              class="label-list"
              v-else-if="detail.subInfo.state == 'to_be_submitted'"
            >
              <li
                :class="{ choose: item.isChoose }"
                v-for="(item, index) in labelData.list"
                :key="item.id"
                @click="viewResult(item, index, 'img' + index)"
                :ref="'img' + index"
              >
                <figure>
                  <a-image
                    style="width: auto; max-height: 157px"
                    :preview="false"
                    :src="appConfig.baseImgUrl + item.item.accessSrc"
                    fallback="data:image/png;base64,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"
                  >
                  </a-image>
                  <figcaption class="fig">
                    <p class="name">{{ item.item.id }}</p>
                  </figcaption>
                </figure>
                <a-tag
                  v-if="item?.tags?.length"
                  color="#2db7f5"
                  style="
                    position: absolute;
                    right: -10px;
                    top: -10px;
                    border-radius: 5px;
                  "
                  >{{ item.tags[0] }}</a-tag
                >
              </li>
            </ul>

            <!-- 标注中  -->
            <!-- <ul class="label-list" v-else-if="detail.subInfo.state == 'in_labeling'">
              <li :class="{choose:item.isChoose}" v-for="(item, index) in labelData.list" :key="item.id"  @click="viewResult(item, index, 'img' + index)" :ref="'img' + index">
                <figure>
                  <a-image  
                    :preview="false"
                    :src="appConfig.baseImgUrl + item.item.accessSrc"
                    fallback="data:image/png;base64,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"
                  >
                  </a-image>
                  <figcaption class="fig">
                    <p class="name">{{item.item.id}}</p>
                  </figcaption>
                </figure>
              </li>
            </ul> -->

            <!-- 其它  -->
            <ul v-else class="label-list">
              <li
                v-for="(item, index) in labelData.list"
                :key="item.id"
                @click="viewResult(item, index, 'img' + index)"
                :ref="'img' + index"
              >
                <figure>
                  <!--   @click="previewImg(index)" -->
                  <a-image
                    style="width: auto; max-height: 157px"
                    :preview="false"
                    :src="appConfig.baseImgUrl + item.item.accessSrc"
                    fallback="data:image/png;base64,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"
                  >
                  </a-image>
                  <figcaption class="fig">
                    <p class="name">{{ item.item.id }}</p>
                  </figcaption>
                </figure>
                <a-tag
                  v-if="item?.tags?.length"
                  color="#2db7f5"
                  style="
                    position: absolute;
                    right: -10px;
                    top: -10px;
                    border-radius: 5px;
                  "
                  >{{ item.tags[0] }}</a-tag
                >
              </li>
            </ul>
            <!--  end ---->

            <div class="mt20">
              <a-pagination
                style="float: right; margin-right: 30px"
                v-model:current="labelData.page.num"
                show-quick-jumper
                :pageSize="labelData.page.size"
                :total="labelData.page.total"
                :show-total="(total) => `共 ${total} 条`"
                @change="getDataItem"
              ></a-pagination>
            </div>
          </a-card>
        </div>

        <div v-else>
          <a-card
            class="label-wrap mt20"
            title="标注数据"
            v-if="detail.from != 'main'"
          >
            <div class="clearfix">
              <a-form
                class="mb20 fr"
                v-if="true"
                layout="inline"
                :model="searchForm"
              >
                <a-form-item>
                  <a-input
                    v-model:value="searchForm.keyword"
                    placeholder="请输入文件名查询"
                  >
                  </a-input>
                </a-form-item>

                <a-form-item>
                  <a-button @click="search" type="primary" html-type="submit">
                    查询
                  </a-button>
                </a-form-item>
              </a-form>
            </div>
            <div v-if="detail.page == 'operate'">
              <div class="filter-wrap mb20">
                标注数据：
                <span
                  @click="filterLabel()"
                  :class="{ cur: filterData.status == '' }"
                  >全部</span
                >
                <span
                  :class="{ cur: filterData.status == 'success' }"
                  @click="filterLabel('success')"
                  >通过</span
                >
                <span
                  :class="{ cur: filterData.status == 'failure' }"
                  @click="filterLabel('failure')"
                  >不通过</span
                >
              </div>
              <div
                class="hd mb20"
                v-if="detail.subInfo.state == 'in_accepting'"
              >
                <div>
                  <a-checkbox
                    @click="checkAll"
                    v-model:checked="inspectData.checked"
                    >全选</a-checkbox
                  >
                  <a-button class="mr15" @click="acceptanceAction('success')"
                    >标记合格</a-button
                  >
                  <a-button @click="acceptanceAction('failure')"
                    >标记不合格</a-button
                  >
                  <span class="ml20 fullview">鼠标双击图片查看数据详情</span>
                </div>
                <div style="position: absolute; right: 30px; top: 135px">
                  <a-button type="primary" @click="getSubDetail('success')"
                    >初验通过</a-button
                  >
                  <a-button
                    class="ml20"
                    @click="inspectHandle('failure')"
                    type="primary"
                    >初验不通过</a-button
                  >
                </div>
              </div>
              <ul class="label-list">
                <li
                  :class="{ choose: item.isChoose }"
                  v-for="(item, index) in labelData.list"
                  :key="item.id"
                  @click="toogleChange(index)"
                  @dblclick="viewResult(item, index, 'img' + index)"
                  :ref="'img' + index"
                >
                  <figure>
                    <a-image
                      style="width: auto; max-height: 157px"
                      :preview="false"
                      :src="appConfig.baseImgUrl + item.item.accessSrc"
                      fallback="data:image/png;base64,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"
                    >
                    </a-image>
                    <figcaption
                      class="fig"
                      :class="{
                        error: item.acceptanceState == 'failure',
                        sucess: item.acceptanceState == 'success',
                      }"
                    >
                      <p class="name">{{ item.item.id }}</p>
                    </figcaption>
                  </figure>
                  <a-tag
                    v-if="item?.tags?.length"
                    color="#2db7f5"
                    style="
                      position: absolute;
                      right: -10px;
                      top: -10px;
                      border-radius: 5px;
                    "
                    >{{ item.tags[0] }}</a-tag
                  >
                </li>
              </ul>
              <div class="mt20">
                <a-pagination
                  style="float: right; margin-right: 30px"
                  v-model:current="labelData.page.num"
                  show-quick-jumper
                  :pageSize="labelData.page.size"
                  :total="labelData.page.total"
                  :show-total="(total) => `共 ${total} 条`"
                  @change="getDataItem"
                ></a-pagination>
              </div>
            </div>

            <div v-if="detail.page == 'inspect'">
              <div class="filter-wrap mb20">
                标注数据：
                <span
                  @click="filterLabel()"
                  :class="{ cur: filterData.status == '' }"
                  >全部</span
                >
                <span
                  :class="{ cur: filterData.status == 'success' }"
                  @click="filterLabel('success')"
                  >通过</span
                >
                <span
                  :class="{ cur: filterData.status == 'failure' }"
                  @click="filterLabel('failure')"
                  >不通过</span
                >
              </div>
              <div
                class="hd mb20"
                v-if="detail.subInfo.state == 'in_inspecting'"
              >
                <div>
                  <a-checkbox
                    @click="checkAll"
                    v-model:checked="inspectData.checked"
                    >全选</a-checkbox
                  >
                  <a-button class="mr15" @click="inspectAction('success')"
                    >标记合格</a-button
                  >
                  <a-button @click="inspectAction('failure')"
                    >标记不合格</a-button
                  >
                  <span class="ml20 fullview">鼠标双击图片查看数据详情</span>
                </div>
                <div style="position: absolute; right: 30px; top: 85px">
                  <a-button type="primary" @click="getSubDetail('success')"
                    >质检通过</a-button
                  >
                  <a-button
                    class="ml20"
                    @click="getSubDetail('failure')"
                    type="primary"
                    >质检不通过</a-button
                  >
                </div>
              </div>
              <ul class="label-list">
                <li
                  :class="{ choose: item.isChoose }"
                  v-for="(item, index) in labelData.list"
                  :key="item.id"
                  @click="toogleChange(index)"
                  @dblclick="viewResult(item, index, 'img' + index)"
                  :ref="'img' + index"
                >
                  <figure>
                    <a-image
                      style="width: auto; max-height: 157px"
                      :preview="false"
                      :src="appConfig.baseImgUrl + item.item.accessSrc"
                      fallback="data:image/png;base64,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"
                    >
                    </a-image>
                    <figcaption
                      class="fig"
                      :class="{
                        error: item.qualityState == 'failure',
                        sucess: item.qualityState == 'success',
                      }"
                    >
                      <p class="name">{{ item.item.id }}</p>
                    </figcaption>
                  </figure>
                  <a-tag
                    v-if="item?.tags?.length"
                    color="#2db7f5"
                    style="
                      position: absolute;
                      right: -10px;
                      top: -10px;
                      border-radius: 5px;
                    "
                    >{{ item.tags[0] }}</a-tag
                  >
                </li>
              </ul>
              <div class="mt20">
                <a-pagination
                  style="float: right; margin-right: 30px"
                  v-model:current="labelData.page.num"
                  show-quick-jumper
                  :pageSize="labelData.page.size"
                  :total="labelData.page.total"
                  :show-total="(total) => `共 ${total} 条`"
                  @change="getDataItem"
                ></a-pagination>
              </div>
            </div>
          </a-card>
        </div>
      </a-tab-pane>
    </a-tabs>

    <a-card
      class="label-wrap mt20"
      title="标注数据"
      v-if="detail.from == 'main'"
    >
      <div class="clearfix">
        <a-form class="mb20 fr" v-if="true" layout="inline" :model="searchForm">
          <a-form-item>
            <a-input
              v-model:value="searchForm.keyword"
              placeholder="请输入文件名查询"
            >
            </a-input>
          </a-form-item>

          <a-form-item>
            <a-button @click="search" type="primary" html-type="submit">
              查询
            </a-button>
          </a-form-item>
        </a-form>
      </div>

      <ul class="label-list">
        <li
          v-for="(item, index) in labelData.list"
          :key="item.id"
          @click="viewResult(item, index, 'img' + index)"
          :ref="'img' + index"
        >
          <figure>
            <!-- appConfig.baseImgUrl + item.item.accessSrc
             
            @click="previewImg(index)"
            -->
            <a-image
              style="width: auto; max-height: 157px"
              :preview="false"
              :src="appConfig.baseImgUrl + item.item.accessSrc"
              fallback="data:image/png;base64,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"
            >
            </a-image>
            <figcaption class="fig">
              <p class="name">{{ item.item.id }}</p>
            </figcaption>
          </figure>
          <a-tag
            v-if="item?.tags?.length"
            color="#2db7f5"
            style="
              position: absolute;
              right: -10px;
              top: -10px;
              border-radius: 5px;
            "
            >{{ item.tags[0] }}</a-tag
          >
        </li>
      </ul>
      <div class="mt20">
        <a-pagination
          style="float: right; margin-right: 30px"
          v-model:current="labelData.page.num"
          show-quick-jumper
          :pageSize="labelData.page.size"
          :total="labelData.page.total"
          :show-total="(total) => `共 ${total} 条`"
          @change="getDataItem"
        ></a-pagination>
      </div>
    </a-card>
  </a-card>

  <div class="reslutModal" v-show="viewData.showMark">
    <!-- @click="fullView(viewData.curData.previewPath) -->
    <div class="close" @click="closeModal">X</div>
    <div class="m-body flex">
      <div class="">
        <div class="img-wrap mb20 relative">
          <div
            id="map"
            ref="map"
            style="position: relative; width: 800px; height: 500px"
          ></div>

          <!-- <img :src="getViewUrl(viewData.curData.previewPath)" /> -->
        </div>
        <!-- <div v-for="(value, key) in colorMap" style="display: inline-block;margin-right: 10px;" :index="key">
          {{key}} : <span :style="'margin-left:5px;padding:1px 10px;background-color:' + value"></span>
        </div> -->
        <a-tag
          v-if="viewData.curData?.tags?.length"
          color="#2db7f5"
          style="border-radius: 5px"
          >{{ viewData.curData.tags.join(",") }}</a-tag
        >
      </div>
      <div class="ml20 result-wrap relative">
        <p class="mb10 tc filename">
          数据文件名称：<span>
            {{
              viewData.curData.item.accessSrc?.split("/")[
                viewData.curData.item.accessSrc?.split("/").length - 1
              ]
            }}</span
          >
        </p>
        <p class="mb10 tc filename">
          数据文件编号：<span> {{ viewData.curData.item.id }}</span>
        </p>
        <p class="mb20 mt15">识别结果：</p>
        <div class="result-wrap-text mb20">
          <!-- labelmeDate   viewData.curData.labelData.label -->
          <json-viewer
            :value="viewData.curData.label"
            copyable
            :expand-depth="5"
            :show-array-index="false"
          ></json-viewer>
        </div>
        <div class="flex">
          <dl
            class="flex mr30"
            v-if="
              viewData.curData.qualityState &&
              detail.info.labelType != 'offline'
            "
            style="margin-bottom: 0"
          >
            <dt>质检状态：</dt>
            <dd>{{ statusTrans(viewData.curData.qualityState) }}</dd>
          </dl>
          <dl
            class="flex"
            v-if="
              viewData.curData.acceptanceState &&
              (roleId == 7 || roleId == 8 || roleId == 11 || roleId == 12)
            "
          >
            <!-- && detail.page == 'operate' -->
            <dt>初验状态：</dt>
            <dd class="mr20">
              {{ statusTrans2(viewData.curData.acceptanceState) }}
            </dd>
          </dl>

          <div
            v-if="
              detail.page == 'operate' && detail.subInfo.state == 'in_accepting'
            "
          >
            <a-button
              ghost
              type="primary"
              @click="acceptanceAction2('success', viewData.curData.id)"
              >通过</a-button
            >
            <a-button
              ghost
              class="ml20"
              @click="acceptanceAction2('failure', viewData.curData.id)"
              type="danger"
              >不通过</a-button
            >
          </div>
          <div
            v-if="
              detail.page == 'inspect' &&
              detail.subInfo.state == 'in_inspecting'
            "
          >
            <a-button
              ghost
              type="primary"
              @click="inspectAction2('success', viewData.curData.id)"
              >通过</a-button
            >
            <a-button
              ghost
              class="ml20"
              @click="inspectAction2('failure', viewData.curData.id)"
              type="danger"
              >不通过</a-button
            >
          </div>
        </div>

        <div class="btn-wrap mt20 tc">
          <a-button type="primary" @click="prevResult" class="mr20"
            >上一张</a-button
          >
          <a-button type="primary" @click="nextResult">下一张</a-button>
        </div>
      </div>
    </div>
  </div>

  <div class="mark" v-if="viewData.showMark"></div>

  <!--  拒绝弹框 -->
  <a-modal
    v-model:visible="inspectData.visible"
    :maskClosable="false"
    title="操作确认"
  >
    <!-- <a-textarea v-model:value="inspectData.reason" placeholder="请输入不通过理由" :rows="4" /> -->
    <p>是否确认此操作？</p>
    <template #footer>
      <a-button key="back" @click="inspectData.visible = false">取消</a-button>
      <a-button
        key="submit"
        type="primary"
        :loading="inspectData.loading"
        @click="noPass(inspectData.state)"
        >确认</a-button
      >
    </template>
  </a-modal>

  <!--  确认弹框 -->
  <a-modal
    v-model:visible="confirmModal.visible"
    :maskClosable="false"
    title="操作确认"
  >
    <p>存在标记不合格的任务数据，是否确认任务质检通过？</p>
    <template #footer>
      <a-button key="back" @click="confirmModal.visible = false">取消</a-button>
      <a-button
        v-if="detail.page == 'operate'"
        key="submit"
        type="primary"
        :loading="confirmModal.loading"
        @click="taskCheck('success')"
        >确认</a-button
      >
      <a-button
        v-if="detail.page == 'inspect'"
        key="submit"
        type="primary"
        :loading="confirmModal.loading"
        @click="taskInspect('success')"
        >确认</a-button
      >
    </template>
  </a-modal>
</template>
<script>
import Globalnfo from "./Globalnfo";
import { publicConfig } from "@/publicConfig.js";
import { useRoute, useRouter } from "vue-router";
import {
  forView,
  subForView,
  dataItem,
  inspect,
  acceptance,
  completed,
  inspectCompleted,
  subSubmit,
  subDetail,
} from "@/api/taskRelease";
import { reactive, getCurrentInstance, onMounted, computed } from "vue";
import AILabel from "ailabel";
import { mapState } from "vuex";
import router from "../../../router";
import { message } from "ant-design-vue";
import { useStore } from "@/store/index2";

function getRandomColor() {
  return "#" + Math.floor(Math.random() * 16777215).toString(16);
}

let colorList = [
  "lawngreen",
  "red",
  "skyblue",
  "aqua",
  "#f7d731",
  "#c6249a",
  "#0fdfb9",
  "#db3112",
  "#bf70ed",
  "#00bcd4",
  "#009688",
  "#3f51b5",
  "#ff5722",
  "#010101",
  "#a4b02d",
  "#8a4af3",
  "#d40052",
  "#2196f3",
  "#7cdc39",
  "yellow",
];
let colorIndex = 0;

export default {
  components: {
    Globalnfo,
  },

  data() {
    return {
      chooseData: [],
      imgUrl: "",
      drawingStyle: {},
      mode: "",
      itemName: "",
      editId: "",
      colorMap: {},
      searchForm: {
        keyword: "",
      },
    };
  },
  // watch: {
  //   mode(mode) {
  //     this.gMap.setMode(mode);
  //     this.setDrawingStyle(mode);
  //   }
  // },
  computed: {
    ...mapState(["appConfig"]),
  },
  methods: {
    initCanvas() {
      let that = this;
      const gMap = new AILabel.Map("map", {
        center: {
          x: this.viewData.imgInfo.width / 2,
          y: this.viewData.imgInfo.height / 2,
        }, // 为了让图片居中
        zoom: this.viewData.imgInfo.width,
        mode: "BAN", // 绘制线段  PAN
        refreshDelayWhenZooming: true, // 缩放时是否允许刷新延时，性能更优
        zoomWhenDrawing: false,
        panWhenDrawing: false,
        zoomWheelRatio: 5, // 控制滑轮缩放缩率[0, 10), 值越小，则缩放越快，反之越慢
        withHotKeys: false, // 关闭快捷键
      });
      //gMap.setEditingColor('#FFF');
      that.gMap = gMap;

      this.$refs.map.style = `width:${this.viewData.imgInfo.width}px; height:${this.viewData.imgInfo.height}px;transform: scale(0.95)`;

      // 图片层添加
      debugger;
      console.log(that.viewData);
      let u = "";
      if (that.viewData.curData.item) {
        u = that.appConfig.baseImgUrl + that.viewData.curData.item.accessSrc;
      }
      console.log("u");
      console.log(u);
      const gFirstImageLayer = new AILabel.Layer.Image(
        "first-layer-image", // id
        {
          src: u,
          width: this.viewData.imgInfo.width,
          height: this.viewData.imgInfo.height,
          crossOrigin: true, // 如果跨域图片，需要设置为true
          position: {
            // 左上角相对中心点偏移量
            x: 0, //-18
            y: 0,
          },
          // grid: { // 3 * 3
          //   columns: [{color: '#9370DB'}, {color: '#FF6347'}],
          //   rows: [{color: '#9370DB'}, {color: '#FF6347'}]
          // }
        }, // imageInfo
        { name: "第一个图片图层" }, // props
        { zIndex: 1 } // style
      );
      // 添加到gMap对象
      gMap.addLayer(gFirstImageLayer);
      // 添加矢量图层
      const gFirstFeatureLayer = new AILabel.Layer.Feature(
        "first-layer-feature", // id
        { name: "第一个矢量图层" }, // props
        { zIndex: 200 } // style
      );
      this.gFirstFeatureLayer = gFirstFeatureLayer;
      gMap.addLayer(gFirstFeatureLayer);

      window.onresize = function () {
        that.gMap && that.gMap.resize();
      };
    },
    previewImg(index) {
      console.log(this.labelData.list.length);
      let tmp = JSON.parse(JSON.stringify(this.labelData.list));
      let arr = [];

      for (let index in tmp) {
        arr.push(tmp[index]);
      }

      let arr2 = arr.map((item) => {
        return this.appConfig.baseImgUrl + item.item.accessSrc;
      });

      this.$hevueImgPreview({
        multiple: true, // 开启多图预览模式
        nowImgIndex: index, // 多图预览，默认展示第二张图片
        imgList: arr2, // 需要预览的多图数组,
        changeFn(img) {
          console.log(img);
          if (img.fromImgIndex == 0) {
          }
        },
      });
    },
    zoomIn() {
      this.gMap.zoomIn();
    },
    zoomOut() {
      this.gMap.zoomOut();
    },
    setMode(mode) {
      this.mode = mode;
    },
    // 获取所有features
    getFeatures() {
      const allFeatures = this.gFirstFeatureLayer.getAllFeatures();

      console.log("--allFeatures--", allFeatures);

      return allFeatures;
      //JSON.parse(JSON.stringify(allFeatures))
    },
    // 初始样式
    setDrawingStyle(mode) {
      let drawingStyle = {};
      switch (mode) {
        case "PAN": {
          break;
        }
        case "MARKER": {
          // 忽略
          break;
        }
        case "POINT": {
          this.drawingStyle = { fillStyle: "#9370DB" };
          this.gMap.setDrawingStyle(drawingStyle);
          break;
        }
        case "CIRCLE": {
          this.drawingStyle = {
            fillStyle: "#9370DB",
            strokeStyle: "#0000FF",
            lineWidth: 2,
          };
          this.gMap.setDrawingStyle(drawingStyle);
          break;
        }
        case "LINE": {
          this.drawingStyle = {
            strokeStyle: "#FF00FF",
            lineJoin: "round",
            lineCap: "round",
            lineWidth: 10,
            arrow: false,
          };
          this.gMap.setDrawingStyle(drawingStyle);
          break;
        }
        case "POLYLINE": {
          this.drawingStyle = {
            strokeStyle: "#FF1493",
            lineJoin: "round",
            lineCap: "round",
            lineWidth: 10,
          };
          this.gMap.setDrawingStyle(drawingStyle);
          break;
        }
        case "RECT": {
          this.drawingStyle = { strokeStyle: "#0f0", lineWidth: 1 };
          this.gMap.setDrawingStyle(drawingStyle);
          break;
        }
        case "POLYGON": {
          this.drawingStyle = {
            strokeStyle: "#00f",
            fillStyle: "#0f0",
            globalAlpha: 0.3,
            lineWidth: 1,
            fill: true,
            stroke: true,
          };
          this.gMap.setDrawingStyle(drawingStyle);
          break;
        }
        case "DRAWMASK": {
          this.drawingStyle = {
            strokeStyle: "rgba(255, 0, 0, .5)",
            fillStyle: "#00f",
            lineWidth: 50,
          };
          this.gMap.setDrawingStyle(drawingStyle);
          break;
        }
        case "CLEARMASK": {
          this.drawingStyle = { fillStyle: "#00f", lineWidth: 30 };
          this.gMap.setDrawingStyle(drawingStyle);
          break;
        }
        default:
          break;
      }
    },
    // 添加图形
    addFeature(data, type, name) {
      let that = this;
      let drawingStyle = this.drawingStyle;

      //let colorMap = {}
      if (type === "LINE") {
        const scale = that.gMap.getScale();
        const width = drawingStyle.lineWidth / scale;
        let { arr, category, labelData } = data;

        // arr.forEach((item, index)=>{
        //   this.colorMap[item.category] =   this.colorMap[item.category] ? this.colorMap[item.category] : colorList[index]
        //   if(colorList.length < arr.length){
        //     this.colorMap[item.category] = 'lawngreen'
        //   }
        // })

        const lineFeature = new AILabel.Feature.Line(
          `${+new Date()}`, // id
          { ...labelData, width }, // shape
          { name }, // props
          { strokeStyle: this.colorMap[category], lineWidth: 1.2 } // style
        );
        that.gFirstFeatureLayer.addFeature(lineFeature);
      } else if (type === "POLYLINE") {
        const scale = that.gMap.getScale();
        const width = drawingStyle.lineWidth / scale;
        let { arr, category, labelData } = data;
        //let colorMap = {}
        // arr.forEach((item, index)=>{
        //   this.colorMap[item.category] =  this.colorMap[item.category] ? this.colorMap[item.category] : colorList[index]
        //   if(colorList.length < arr.length){
        //     this.colorMap[item.category] = 'lawngreen'
        //   }
        // })
        const polylineFeature = new AILabel.Feature.Polyline(
          `${+new Date()}`, // id
          { points: labelData, width }, // shape
          { name }, // props
          { strokeStyle: this.colorMap[category], lineWidth: 1.5 }
          //drawingStyle // style
        );
        that.gFirstFeatureLayer.addFeature(polylineFeature);
      } else if (type === "RECT") {
        let { arr, category, labelData } = data;

        //let colorMap = {}
        // arr.forEach((item, index)=>{
        //   this.colorMap[item.category] =   this.colorMap[item.category] ? this.colorMap[item.category] : colorList[index]
        //   if(colorList.length < arr.length){
        //     this.colorMap[item.category] = 'lawngreen'
        //   }
        // })

        const rectFeature = new AILabel.Feature.Rect(
          `${+new Date()}`, // id
          labelData, // shape
          { name }, // props
          { strokeStyle: this.colorMap[category], lineWidth: 1.2 } // style
        );
        that.gFirstFeatureLayer.addFeature(rectFeature);
      } else if (type === "POLYGON") {
        let { arr, category, labelData } = data;
        //let colorMap = {}
        // arr.forEach((item, index)=>{
        //   this.colorMap[item.category] =   this.colorMap[item.category] ? this.colorMap[item.category] : colorList[index]
        //   if(colorList.length < arr.length){
        //     this.colorMap[item.category] = 'lawngreen'
        //   }
        // })

        const polygonFeature = new AILabel.Feature.Polygon(
          `${+new Date()}`, // id
          { points: labelData }, // shape
          { name }, // props
          //drawingStyle // style
          { strokeStyle: this.colorMap[category], lineWidth: 1.5 }
        );
        that.gFirstFeatureLayer.addFeature(polygonFeature);
      } else if (type === "CIRCLE") {
        let { arr, category, labelData } = data;
        //let colorMap = {}
        // arr.forEach((item, index)=>{
        //   this.colorMap[item.category] =   this.colorMap[item.category] ? this.colorMap[item.category] : colorList[index]
        //   if(colorList.length < arr.length){
        //     this.colorMap[item.category] = 'lawngreen'
        //   }
        // })
        const circleFeature = new AILabel.Feature.Circle(
          `${+new Date()}`, // id
          labelData, // shape
          { name }, // props
          { strokeStyle: this.colorMap[category], lineWidth: 2 } // style
        );

        that.gFirstFeatureLayer.addFeature(circleFeature);
      } else if (type === "POINT") {
        let { arr, category, labelData } = data;
        //let colorMap = {}
        // arr.forEach((item, index)=>{
        //   this.colorMap[item.category] =   this.colorMap[item.category] ? this.colorMap[item.category] : colorList[index]
        //   if(colorList.length < arr.length){
        //     this.colorMap[item.category] = 'lawngreen'
        //   }
        // })
        const pointFeature = new AILabel.Feature.Point(
          `${+new Date()}`, // id
          labelData, // shape

          { name }, // props
          { strokeStyle: this.colorMap[category], lineWidth: 2 } // style
        );

        that.gFirstFeatureLayer.addFeature(pointFeature);
      }
    },
  },
  setup() {
    const instance = getCurrentInstance();
    debugger;
    console.log(instance);
    const route = useRoute();
    const router = useRouter();
    const westCurrentRole = JSON.parse(localStorage.getItem("westCurrentRole"));

    const roleId = westCurrentRole.roleId;

    const labelTaskId = route.query.taskId || "";
    const labelTaskSubId = route.query.subTaskId || "";

    const detail = reactive({
      from: "",
      page: route.query.page,
      type: route.query.type,
      info: {
        dataset: {},
        project: {},
        purchaseManager: {},
      },
      subInfo: {},
      subTask: [],
      activeKey: "",
    });

    const inspectData = reactive({
      visible: false,
      state: "",
      checked: computed(() => {
        return labelData.list.every((item) => {
          return item.isChoose;
        });
      }),
      chooseList: computed(() => {
        return labelData.list.filter((item) => {
          return item.isChoose;
        });
      }),
    });

    function toogleChange(index) {
      debugger;
      labelData.list[index].isChoose = !labelData.list[index].isChoose;
    }

    function checkAll() {
      if (inspectData.checked) {
        labelData.list.forEach((item) => {
          item.isChoose = false;
        });
      } else {
        labelData.list.forEach((item) => {
          item.isChoose = true;
        });
      }
    }

    function inspectHandle(state) {
      inspectData.visible = true;
      inspectData.state = state;
    }

    let confirmModal = reactive({
      visible: false,
      loading: false,
    });

    // 质检
    async function taskInspect(result) {
      confirmModal.visible = false;
      let params = {
        labelTaskSubId: route.query.subTaskId,
        result,
      };
      const { data: res } = await inspectCompleted(params);
      if (res.code == "0") {
        message.success(res.msg);
        getForView();
        getSubForView();
        getDataItem();
      } else {
        message.error(res.msg);
      }
    }

    //  获取子任务数据统计
    async function getSubDetail(result) {
      let params = {
        labelTaskSubId: route.query.subTaskId,
      };

      const { data: res } = await subDetail(params);
      if (res.code == 0) {
        if (detail.page == "operate") {
          //初验
          if (res.data.acceptanceFailure > 0) {
            confirmModal.visible = true;
          } else {
            taskCheck("success");
          }
        }
        if (detail.page == "inspect") {
          //质检
          if (res.data.qualityUnCheck > 0) {
            message.error(`你有${res.data.qualityUnCheck}条数据质检未完成`);
          } else {
            if (result == "success") {
              if (res.data.qualityFailure > 0) {
                message.error(
                  `存在标记不合格的图片数据，请再次确认不合格图片后再进行操作`
                );
              } else {
                taskInspect("success");
              }
            } else {
              if (res.data.qualityUnCheck > 0) {
                message.error(`你有${res.data.qualityUnCheck}条数据质检未完成`);
              } else {
                if (res.data.qualityFailure > 0) {
                  taskInspect("failure");
                } else {
                  message.error(
                    `子任务所有图片质检均合格，请再次确认后进行操作！`
                  );
                }
              }
            }
          }

          // if(res.data.qualityFailure > 0){
          //   confirmModal.visible = true
          // }else{
          //   taskInspect('success')
          // }
        }
      } else {
        message.error(res.msg);
      }
    }

    // 初验
    async function taskCheck(result) {
      let params = {
        labelTaskSubId: route.query.subTaskId,
        result,
      };
      const { data: res } = await completed(params);
      if (res.code == "0") {
        message.success(res.msg);
        getForView();
        getSubForView();
        getDataItem();
      } else {
        message.error(res.msg);
      }
    }

    function noPass(result) {
      if (detail.page == "operate") {
        taskCheck(result).then(() => {
          inspectData.visible = false;
          inspectData.loading = false;
        });
      }
      if (detail.page == "inspect") {
        //质检
        taskInspect(result).then(() => {
          inspectData.visible = false;
          inspectData.loading = false;
        });
      }
    }

    //  初验
    async function acceptanceAction(state) {
      let detailIds = inspectData.chooseList.map((item) => {
        return item.id;
      });

      let opType = "";

      if (detailIds.length == 0) {
        message.error("请至少选择一条数据");
        return;
      }
      let params = {
        detailIds,
        opType: "ACCEPTANCE",
        state,
      };

      const { data: res } = await acceptance(params);
      if (res.code == "0") {
        message.success(res.msg);
        getDataItem();
      } else {
        message.error(res.msg);
      }
    }

    // 初验
    async function acceptanceAction2(state, id) {
      let detailIds = [id];
      let params = {
        detailIds,
        opType: "ACCEPTANCE",
        state,
      };

      const { data: res } = await acceptance(params);
      if (res.code == "0") {
        message.success(res.msg);
        //getSubForView()
        viewData.curData.acceptanceState = state;
        getDataItem();
      } else {
        message.error(res.msg);
      }
    }

    // 质检 /  初验
    async function inspectAction(state) {
      // let chooseArr = inspectData.list.filter((item)=>{
      //   return item.isChoose
      // })

      let detailIds = inspectData.chooseList.map((item) => {
        return item.id;
      });

      let opType = "";
      if (detail.page == "operate") {
        //初验
        opType = "ACCEPTANCE";
      }
      if (detail.page == "inspect") {
        //质检
        opType = "QUALITY";
      }

      if (detailIds.length == 0) {
        message.error("请至少选择一条数据");
        return;
      }
      let params = {
        detailIds,
        opType,
        state,
      };

      const { data: res } = await inspect(params);
      if (res.code == "0") {
        message.success(res.msg);
        getDataItem();
      } else {
        message.error(res.msg);
      }
    }

    // 质检 /  初验
    async function inspectAction2(state, id) {
      // let chooseArr = inspectData.list.filter((item)=>{
      //   return item.isChoose
      // })

      debugger;
      let detailIds = [id];

      let opType = "";
      if (detail.page == "operate") {
        //初验
        opType = "ACCEPTANCE";
      }
      if (detail.page == "inspect") {
        //质检
        opType = "QUALITY";
      }

      let params = {
        detailIds,
        opType,
        state,
      };

      const { data: res } = await inspect(params);
      if (res.code == "0") {
        message.success(res.msg);
        //getSubForView()

        viewData.curData.qualityState = state;

        getDataItem().then((a) => {
          console.log(a);
          // viewData.curData.id = result.id
          // viewData.curData.item = {...result.item}
          // viewData.curData.qualityState = result.qualityState
          // viewData.curData.acceptanceState = result.acceptanceState
          // viewData.curData.label = result.labelData ? {...result.labelData.label} : {}
          // viewData.curData.labelmeDate = JSON.parse(result.labelmeDate)
        });
      } else {
        message.error(res.msg);
      }
    }

    async function checkAction(state) {
      let chooseArr = inspectData.list.filter((item) => {
        return item.isChoose;
      });

      let detailIds = chooseArr.list.map((item) => {
        return item.id;
      });

      let params = {
        detailIds,
        opType: "ACCEPTANCE",
        state,
      };
      const { data: res } = await inspect(params);
      if (res.code == "0") {
        message.success(res.msg);
      } else {
        message.error(res.msg);
      }
    }

    detail.from = route.query.from;
    detail.subTask = JSON.parse(localStorage.getItem("subTask"));
    detail.activeKey = route.query.subTaskId;

    const itemData = reactive({
      list: [],
      page: {
        num: 1,
        size: 10,
        total: 0,
      },
    });

    const labelData = reactive({
      list: [],
      page: {
        num: 1,
        size: 20,
        total: 0,
      },
    });

    let subLabelData = reactive({
      list: [],
      page: {
        num: 1,
        size: 20,
        total: 0,
      },
    });

    function search() {
      labelData.page.num = 1;
      getDataItem();
    }

    async function getDataItem() {
      console.log("getDataItem");

      let from = route.query.from;
      let params = {
        //labelTaskSubId,
        // acceptanceStates:filterData.status,
        // qualityState:filterData.status,
        keyword: instance.data.searchForm.keyword,
        pageNum: labelData.page.num,
        pageSize: labelData.page.size,
      };
      debugger;

      if (from == "main") {
        params.labelTaskId = labelTaskId;
      } else {
        params.labelTaskSubId = detail.activeKey;

        if (detail.type != "view") {
          if (detail.page == "operate") {
            //运营商过来 操作初验
            if (filterData.status == "") {
              params.acceptanceStates = "to_be_accepted,success,failure"; //success
            } else {
              params.acceptanceStates = filterData.status; //验收
            }
          }

          if (detail.page == "inspect") {
            //质检员过来   操作质检
            params.qualityState = filterData.status; //质检
          }
        }
      }

      const { data: res } = await dataItem(params);
      labelData.page.total = res.data.total;

      labelData.list = [...res.data.records];
      labelData.list.forEach((item) => {
        item.isChoose = false;
      });
    }

    /*  查看结果   */
    let viewData = reactive({
      visible: false,
      index: 0,
      curData: {
        // previewPath:'https://test-dev.westwell-research.com/testing/preview/files/wellspring/alphaceph/projects/welltesting-dev/2023022300005/CAL_2023022300005_01/images/00be8d6f276b48829e4608a19662d4eb.jpg',
        // dataName:'',
        id: "",
        item: {},
        label: [],
        labelmeDate: {},
      },
      showMark: false,
      imgInfo: {
        width: 0,
        height: 0,
      },
    });

    function prevResult() {
      if (viewData.index > 0) {
        viewData.index--;

        console.log("uuu");
        console.log(instance.ctx);
        instance.ctx.gMap && instance.ctx.gMap.destroy();
        instance.ctx.gMap = null;
        console.log(instance.ctx);
        //viewData.curData.item = labelData.list[index].item

        viewResult(
          labelData.list[viewData.index],
          viewData.index,
          "img" + viewData.index
        );
      }
    }

    function nextResult() {
      if (viewData.index < labelData.list.length - 1) {
        viewData.index++;
        instance.ctx.gMap && instance.ctx.gMap.destroy();
        instance.ctx.gMap = null;
        viewResult(
          labelData.list[viewData.index],
          viewData.index,
          "img" + viewData.index
        );
      }
    }

    function getViewUrl(src) {
      return src;
    }

    function handleClose() {}

    function fullView() {}

    // 查看总任务详情
    async function getForView() {
      let params = {
        labelTaskId,
      };
      const { data: res } = await forView(params);
      detail.info = { ...res.data };
      detail.info.descriptionLink = `${publicConfig.requestUrl}${detail.info.descriptionLink}`;
    }

    getForView();

    async function getSubForView() {
      let params = {
        labelTaskSubId: detail.activeKey,
      };
      debugger;
      const { data: res } = await subForView(params);
      detail.subInfo = { ...res.data };
    }

    function taskChange(activeKey) {
      console.log(activeKey);
      detail.page;
      labelData.page.num = 1;
      getSubForView();
      getDataItem();
    }
    // function previewImg(url){

    //   hevueImgPreview(url)
    // }

    function backHandle() {
      router.back();
    }

    //  查看标注详情
    function viewResult(result, index, el) {
      console.log(
        instance.proxy.$refs[el][0].querySelector("img").naturalWidth
      );
      let naturalWidth =
        instance.proxy.$refs[el][0].querySelector("img").naturalWidth;
      let naturalHeight =
        instance.proxy.$refs[el][0].querySelector("img").naturalHeight;
      viewData.index = index;
      viewData.showMark = true;
      viewData.curData.id = result.id;
      viewData.curData.item = { ...result.item }; //可在此处对数据进行处理 把每个category在对应添加一个color 方便勇于赋值标注线的颜色
      viewData.curData.qualityState = result.qualityState;
      viewData.curData.acceptanceState = result.acceptanceState;
      viewData.curData.tags = result.tags;
      viewData.curData.label = result.labelData
        ? { ...result.labelData.label }
        : {};
      viewData.curData.labelmeDate = JSON.parse(result.labelmeDate);
      viewData.imgInfo.width = naturalWidth;
      viewData.imgInfo.height = naturalHeight;
      console.log(instance.proxy.$refs);
      debugger;
      //instance.proxy.$refs.map.style = `width:${naturalWidth}px; height:${naturalHeight}px; transform: scale(1)`

      //debugger
      // console.log(viewData.curData.label)
      // viewData.curData.label.BOX2D.push(
      //   {
      //     box2d:{
      //         xmin:0,
      //         ymin:0,
      //         xmax:200,
      //         ymax:200,
      //       }
      //   }

      // )

      instance.ctx.initCanvas();

      let usedColor = [];
      for (let key in instance.proxy.$data.colorMap) {
        usedColor.push(instance.proxy.$data.colorMap[key]);
      }

      let filerColor = colorList.filter((item) => !usedColor.includes(item));

      for (let key in viewData.curData.label) {
        console.log(key);
        if (key == "BOX2D") {
          instance.ctx.setMode("RECT");
          viewData.curData.label[key].forEach((item, index, arr) => {
            let labelData = {
              x: item.box2d.xmin, // 需要多加16
              y: item.box2d.ymin, //需要多加4
              width: item.box2d.xmax - item.box2d.xmin,
              height: item.box2d.ymax - item.box2d.ymin,
            };

            if (item.category) {
              if (!instance.proxy.$data.colorMap[item.category]) {
                instance.proxy.$data.colorMap[item.category] =
                  filerColor[index] || getRandomColor();
              }
            }

            let data = {
              arr: arr,
              category: item.category,
              labelData: labelData,
            };
            //instance.ctx.drawingStyle.lineWidth = 5
            //instance.ctx.drawingStyle.strokeStyle = 'green'
            instance.ctx.addFeature(data, "RECT", "rrr");
          });
        } else if (key == "POLYGON") {
          instance.ctx.setMode("POLYGON");

          viewData.curData.label[key].forEach((item, index, arr) => {
            if (item.category) {
              if (!instance.proxy.$data.colorMap[item.category]) {
                instance.proxy.$data.colorMap[item.category] =
                  filerColor[index] || getRandomColor();
              }
            }

            let labelData = [...item.polygon];
            let data = {
              arr: arr,
              category: item.category,
              labelData: labelData,
            };
            //instance.ctx.drawingStyle.lineWidth = 6
            //instance.ctx.drawingStyle.strokeStyle = 'red'
            instance.ctx.addFeature(data, "POLYGON", "ppp");
          });
        } else if (key == "POLYLINE2D") {
          instance.ctx.setMode("POLYLINE");
          viewData.curData.label[key].forEach((item, index, arr) => {
            if (item.category) {
              if (!instance.proxy.$data.colorMap[item.category]) {
                instance.proxy.$data.colorMap[item.category] =
                  filerColor[index] || getRandomColor();
              }
            }
            //let labelData = [...item.polyline2d]
            let data = {
              arr: arr,
              category: item.category,
              labelData: [...item.polyline2d],
            };

            instance.ctx.addFeature(data, "POLYLINE", "ppline");
          });
        } else if (key == "KEYPOINTS2D") {
          instance.ctx.setMode("CIRCLE");
          viewData.curData.label[key].forEach((item, index, arr) => {
            if (item.category) {
              if (!instance.proxy.$data.colorMap[item.category]) {
                instance.proxy.$data.colorMap[item.category] =
                  filerColor[index] || getRandomColor();
              }
            }
            let keypoints2d = item.keypoints2d;
            let labelData = {
              cx: keypoints2d[0].x,
              cy: keypoints2d[0].y,
              r: 3,
            };

            let data = {
              arr: arr,
              category: item.category,
              labelData: labelData,
            };
            // instance.ctx.drawingStyle.lineWidth = 3
            // instance.ctx.drawingStyle.strokeStyle = 'red'
            instance.ctx.addFeature(data, "CIRCLE", "po");
          });
        }
      }

      setTimeout(() => {
        instance.ctx.gMap.resize();
      }, 300);
    }

    function closeModal() {
      viewData.showMark = false;

      if (instance.ctx.gMap) {
        instance.ctx.gMap.destroy();
      }

      instance.ctx.gMap = null;
      console.log(instance.ctx.gMap);
      //instance.ctx.initCanvas()
    }

    function statusTrans(state) {
      let status = "";
      if (state == "success") {
        status = "通过";
      } else if (state == "failure") {
        status = "不通过";
      }
      return status;
    }

    function statusTrans2(state) {
      let status = "";
      if (state == "success") {
        status = "通过";
      } else if (state == "failure") {
        status = "不通过";
      } else if (state == "to_be_accepted") {
        status = "待初验";
      }
      return status;
    }

    let filterData = reactive({
      status: "",
    });

    function filterLabel(state) {
      labelData.page.num = 1;
      if (state) {
        filterData.status = state;
      } else {
        filterData.status = "";
      }

      getDataItem();
    }

    let store = useStore();
    function stateCn(value) {
      return store.getSubStateName(value);
    }

    onMounted(() => {
      getDataItem();
      getSubForView();
      // instance.proxy.$nextTick(()=>{
      //   alert(666)
      // })
      //instance.proxy.$forceUpdate()
    });

    return {
      roleId,
      detail,
      labelData,
      getForView,
      getSubForView,
      getDataItem,
      itemData,
      viewData,
      closeModal,
      handleClose,
      fullView,
      prevResult,
      nextResult,
      getViewUrl,
      taskChange,
      backHandle,
      viewResult,
      inspectData,
      toogleChange,
      checkAll,
      inspectHandle,
      inspectAction,
      checkAction,
      taskInspect,
      taskCheck,
      noPass,
      statusTrans,
      filterData,
      filterLabel,
      confirmModal,
      getSubDetail,
      inspectAction2,
      stateCn,
      statusTrans2,
      acceptanceAction,
      acceptanceAction2,
      search,
      //previewImg,
    };
  },
  mounted() {
    //this.initCanvas()
  },
  beforbeforeDestroy() {
    this.gMap.destroy();
  },
};
</script>
<style lang="less" scoped>
.back {
  position: absolute;
  right: 50px;
  top: 50px;
  z-index: 1;
}
.wrap {
  .con {
    display: flex;
    margin-right: 200px;
    dl {
      display: flex;
    }
  }
}
.label-wrap {
  .hd {
    justify-content: space-between;
  }
}
.label-list {
  display: flex;
  flex-wrap: wrap;
  justify-content: left;
  li {
    position: relative;

    // width: 280px;
    height: 207px;
    display: inline-block;
    margin: 0 20px 30px 20px;
    border: 1px solid #ccc;
    text-align: center;

    box-sizing: content-box;
    .img {
      width: auto !important;
      height: 157px !important;
    }
    .fig {
      margin-top: 10px;
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      text-align: center;
      line-height: 50px;
      height: 50px;
      background: rgba(0, 0, 0, 0.1);
      .name {
        width: 95%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        margin: auto;
      }
    }
    .sucess {
      background-color: green;

      color: #fff;
    }
    .error {
      background-color: red;

      color: #fff;
    }
    .tag {
      display: none;
      position: absolute;
      right: 0;
      top: 10px;
    }
  }
  .choose {
    border: 1px solid blue;
  }
}

.label-list:after {
  content: "";
  width: 285px;
}
.img-wrap {
  display: flex;
  justify-content: center;
  align-items: center;
  // border:1px solid #ddd;
  box-shadow: 0px 0px 3px #ddd;
  width: 750px;
  height: 400px;
  img {
    max-width: 400px;
    max-height: 400px;
  }
}
.filename {
  font-weight: bold;
  font-size: 16px;
}

.result-wrap {
  width: 100%;
  .result-wrap-text {
    height: 290px;
    border: 1px solid #dcdcdc;
    overflow-y: auto;
    padding: 5px;
  }
}

.reslutModal {
  border: 1px soid #ccc;
  width: 90%;
  position: fixed;
  height: 600px;
  top: 9%;
  left: 5%;
  background: #fff;
  z-index: 100;
  padding: 30px;
  padding-top: 60px;
}

.mark {
  width: 100%;
  height: 100%;
  background: #000;
  position: fixed;
  opacity: 0.5;
  top: 0;
  left: 0;
  z-index: 99;
}

.close {
  position: absolute;
  top: 20px;
  font-size: 25px;
  right: 30px;
  cursor: pointer;
}

.filter-wrap {
  span {
    border: 1px solid #ccc;
    border-radius: 15px;
    padding: 3px 8px;
    margin-right: 10px;
    cursor: pointer;
  }
  .cur {
    border-color: #0c2366;
  }
}
.fullview {
  background: antiquewhite;
  padding: 5px 10px;
}
</style>
